import { FMFolderType } from "@/graphql";

export function canManageFolder(
  folder: { canWrite?: boolean | null; type: FMFolderType; path: string },
  isSystemAdmin: boolean,
): boolean {
  if (
    folder.type === FMFolderType.TEMPORARY ||
    folder.type === FMFolderType.LOST_AND_FOUND ||
    folder.path === "02.05" ||
    folder.path.startsWith("02.05.")
  ) {
    return isSystemAdmin;
  }

  return folder.canWrite === true;
}
